import React from "react";
import style from "./style.module.css";

function Button({
  text,
  icon,
  onClick,
  fromLp = false,
}: {
  text: string;
  icon: boolean;
  onClick: any;
  fromLp?: boolean;
}) {
  return (
    <>
      <button
        className={`${style.button} ${fromLp ? style.btnFormLp : ""}`}
        onClick={onClick}
      >
        {icon ? (
          <span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 14L10 10M11.3333 6.66667C11.3333 9.244 9.244 11.3333 6.66667 11.3333C4.08934 11.3333 2 9.244 2 6.66667C2 4.08934 4.08934 2 6.66667 2C9.244 2 11.3333 4.08934 11.3333 6.66667Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        ) : null}
        {text}
      </button>
    </>
  );
}

export default Button;
